import { render, staticRenderFns } from "./SettledList.vue?vue&type=template&id=37730412&scoped=true&"
import script from "./SettledList.vue?vue&type=script&lang=js&"
export * from "./SettledList.vue?vue&type=script&lang=js&"
import style0 from "./SettledList.vue?vue&type=style&index=0&id=37730412&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37730412",
  null
  
)

export default component.exports